import React, { FC } from 'react';
import styled from 'styled-components';
import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';

const LoadingIndicatorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const LoadingIndicator: FC = () => (
  <LoadingIndicatorContainer>
    <CircularLoadingIndicator />
  </LoadingIndicatorContainer>
);

export default LoadingIndicator;
